<!--
	Copyright (c) 2021-present, Bäumer, Afonso, Meissner GmbH
	All rights reserved.
-->
<script setup>
import { useCssVar, useResizeObserver, useWindowScroll } from "@vueuse/core";
import { computed, onMounted, onBeforeUnmount, ref, watch } from "vue";

const SCROLL_THRESHOLD = 55;

const el = ref(null);
const { y } = useWindowScroll();

const headerHeight = useCssVar(
    "--bam-header-height",
    ref(document.documentElement)
);

const { stop } = useResizeObserver(el, (entries) => {
    const entry = entries[0];
    const { blockSize: height } = entry.borderBoxSize[0];
    window.requestAnimationFrame(() => {
        headerHeight.value = `${height}px`;
    });
});

watch(
    [headerHeight],
    ([height]) => {
        headerHeight.value = height;
    },
    { immediate: true }
);

onBeforeUnmount(() => {
    stop();
});
</script>

<template>
    <header
        :class="{
            'the-header': true,
            'the-header--shrunk': y > SCROLL_THRESHOLD,
        }"
        ref="el"
    >
        <slot />
    </header>
</template>
